import React from 'react';
import { RotateCcw } from 'lucide-react';

export const ReturnPolicy = () => {
  return (
    <div className="bg-slate-50 dark:bg-slate-950 min-h-screen">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 pt-24 pb-16 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-500/10 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 bg-blue-600/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-6 border border-blue-500/30">
              <RotateCcw className="w-8 h-8 text-blue-400" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">Política de Devolução</h1>
            <p className="text-slate-300 text-lg max-w-xl mx-auto">
              Condições para trocas e devoluções de produtos.
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-800 p-8 md:p-10 -mt-8 relative z-20">
            <p className="text-slate-600 dark:text-slate-300 mb-8 leading-relaxed">
              Esta Política descreve as condições para trocas e devoluções de produtos adquiridos na PCS Dutos e Exaustores.
            </p>

            <div className="space-y-6">
              <section className="p-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700">
                <h2 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">1. Prazo para solicitação</h2>
                <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
                  Você pode solicitar devolução por arrependimento em até 7 (sete) dias corridos a partir do recebimento, conforme legislação aplicável, quando o produto for comprado à distância.
                </p>
              </section>

              <section className="p-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700">
                <h2 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">2. Condições do produto</h2>
                <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
                  Para devolução/troca, o produto deve estar sem sinais de uso, com embalagem e acessórios (quando aplicável). Em casos de itens personalizados, sob medida ou fabricados sob encomenda, podem existir regras específicas.
                </p>
              </section>

              <section className="p-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700">
                <h2 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">3. Produto com defeito</h2>
                <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
                  Caso identifique defeito, entre em contato o quanto antes. Poderemos solicitar fotos/vídeos e informações para análise. Após validação, faremos a troca, reparo ou reembolso conforme o caso.
                </p>
              </section>

              <section className="p-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700">
                <h2 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">4. Como solicitar</h2>
                <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
                  Solicite pelo WhatsApp/contato do site informando: número do pedido, produto, motivo e dados para retorno.
                </p>
              </section>

              <section className="p-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700">
                <h2 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">5. Reembolso</h2>
                <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">
                  O reembolso será realizado conforme o método de pagamento utilizado e após recebimento/validação do produto devolvido, quando aplicável.
                </p>
              </section>
            </div>

            <p className="text-xs text-slate-400 dark:text-slate-500 mt-8 text-center">
              Última atualização: {new Date().toLocaleDateString('pt-BR')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
